import { MediaDisplay } from "@package/ui-wall-components";
import { get } from "lodash";
import { type PropsWithChildren, useMemo } from "react";
import { useTriviaContext } from "../context-trivia";

export function TriviaContainer({ children }: PropsWithChildren) {
  const { component, screen, questionIndex } = useTriviaContext();

  const buttonColorBackground = useMemo<string>(
    () => get(screen, "flyout.post.customData.buttonColorBackground"),
    [screen],
  );
  const buttonColorText = useMemo<string>(
    () => get(screen, "flyout.post.customData.buttonColorText"),
    [screen],
  );
  const primaryColorBackground = useMemo<string>(
    () => get(screen, "flyout.post.customData.primaryColorBackground"),
    [screen],
  );
  const primaryColorText = useMemo<string>(
    () => get(screen, "flyout.post.customData.primaryColorText"),
    [screen],
  );
  const questions = useMemo<{ question: string }[]>(
    () => get(screen, `flyout.post.customData.trivia.questions`, []),
    [screen],
  );
  const backgroundMedia = useMemo<string>(
    () => get(screen, "flyout.post.customData.backgroundMedia"),
    [screen],
  );

  return (
    <div className="relative h-full w-full">
      {!!backgroundMedia && (
        <div className="absolute top-0 left-0 w-full h-full">
          <MediaDisplay id={backgroundMedia} />
        </div>
      )}
      <div
        className="absolute top-0 left-0 w-full h-full"
        style={{
          backgroundColor: primaryColorBackground,
          color: primaryColorText,
        }}
      >
        <div className="flex flex-col h-full w-full">
          <div className="flex w-full justify-center items-center">
            <div
              className="relative text-5xl px-12 py-8 mt-16 rounded-full"
              style={{
                backgroundColor: buttonColorBackground,
                color: buttonColorText,
              }}
            >
              {component === "result"
                ? "Complete"
                : `Question ${questionIndex + 1} of ${questions.length}`}
            </div>
          </div>
          <div className="flex grow w-full">{children}</div>
        </div>
      </div>
    </div>
  );
}
